import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsUnblindingRequestManagementServices = {
  //Unblinding Request
  addNewEIWRSUnblindingRequest,
  reviewEIWRSUnblindingRequestData,
  getEIWRSUnblindingRequestData,
  getEIWRSUnblindingRequestStats
};

// Add New Unblinding Request
async function addNewEIWRSUnblindingRequest(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSUnblindingRequest`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Unblinding Request
async function reviewEIWRSUnblindingRequestData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}reviewEIWRSUnblindingRequestData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Unblinding Request
async function getEIWRSUnblindingRequestData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingRequestData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingRequestData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Unblinding Request Stats
async function getEIWRSUnblindingRequestStats(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingRequestStats/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}